// extracted by mini-css-extract-plugin
export var subheading = "styles-module--subheading--0dd39";
export var subtitle = "styles-module--subtitle--f5703";